import { render, staticRenderFns } from "./IndividualExamGradePanel.vue?vue&type=template&id=380f92c2&scoped=true"
import script from "./IndividualExamGradePanel.vue?vue&type=script&lang=js"
export * from "./IndividualExamGradePanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualExamGradePanel.vue?vue&type=style&index=0&id=380f92c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f92c2",
  null
  
)

export default component.exports